var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('audio',{ref:"SVIP",attrs:{"src":require("@/assets/MP3/SVIP.mp3")}}),_c('audio',{ref:"quota",attrs:{"src":require("@/assets/MP3/quota.mp3")}}),_c('audio',{ref:"potential",attrs:{"src":require("@/assets/MP3/potential.mp3")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }